module.exports = __webpack_public_path__ + "static/PP6-c1d3ddf74191b43c85c80075053c80c9.jpg";